import React, { useMemo } from "react";
import FullScreen from "src/atoms/FullScreen";
import { SceneLayout } from "src/components/SceneLayout";
import { Button, Flex, Text, chakra } from "@chakra-ui/react";
import { H2, Subtitle } from "src/atoms/typography";
import NavigationButtons from "src/components/NavigationButtons";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation, Trans } from "react-i18next";
import { ReactComponent as AppStore } from "./icons/appstore.svg";
import { ReactComponent as GooglePlay } from "./icons/googleplay.svg";
import { ReactComponent as BarkioStore } from "./icons/barkioStore.svg";
import { ReactComponent as BibinoStore } from "./icons/bibinoStore.svg";
import { useColorModeValue } from "@chakra-ui/react";
import SvgContainer from "src/components/SvgContainer";
import openExternal from "src/utils/openExternal";
import { getAppValue } from "src/utils/environment";

const EnchantedSpan = chakra("span");

const Number = ({ number }) => {
  return (
    <Flex
      bg="primary"
      w="24px"
      minW="24px"
      minH="24px"
      h="24px"
      align="center"
      justify="center"
      borderRadius="100%"
      color="white"
      fontSize="15px"
      fontWeight={700}
    >
      {number}
    </Flex>
  );
};

function DeviceInstall() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { id } = useParams();
  const deviceOptions = useMemo(
    () => ({
      ios: {
        title: "pairing.help.install.ios.title",
        step1: "howToInstall.step1.ios",
        step2: "howToInstall.step2.ios",
        storeIcon: AppStore
      },
      android: {
        title: "pairing.help.install.android.title",
        step1: "howToInstall.step1.android",
        step2: "howToInstall.step2.android",
        storeIcon: GooglePlay
      },
      desktop: {
        title: "pairing.help.install.desktop.title",
        step1: "howToInstall.step1.desktop",
        step2: "howToInstall.step2.desktop"
      }
    }),
    []
  );

  const selectedDevice = deviceOptions[id];
  const bg = useColorModeValue("black4", "white20");
  return (
    <>
      <NavigationButtons
        mode="fullScreen"
        onBack={() => navigate("/how-it-works")}
      />
      <FullScreen>
        <SceneLayout
          center={
            <Flex flexDir="column" textAlign="center" maxW="320px">
              <H2>{t(selectedDevice.title)}</H2>
              <Flex columnGap="8px" mt="16px">
                <Number number={1} />
                <Flex flexDir="column" justifyContent="center">
                  <Subtitle color="mediumEmphasis" textAlign="left">
                    {
                      <Trans
                        i18nKey={selectedDevice.step1}
                        components={
                          id === "desktop"
                            ? {
                                a: (
                                  <EnchantedSpan
                                    color="primary"
                                    textDecoration="none"
                                    cursor="pointer"
                                    onClick={() =>
                                      openExternal({
                                        url: getAppValue({
                                          bibino: "https://bibinoapp.com/",
                                          barkio: "https://barkio.com/"
                                        })
                                      })
                                    }
                                  >
                                    www.barkio.com
                                  </EnchantedSpan>
                                )
                              }
                            : {
                                value0: (
                                  <SvgContainer
                                    icon={selectedDevice.storeIcon}
                                  />
                                )
                              }
                        }
                      />
                    }
                  </Subtitle>
                  {selectedDevice.storeIcon && (
                    <Flex
                      py="10px"
                      pl="10px"
                      pr="20px"
                      bg={bg}
                      borderRadius="16px"
                      mt="16px"
                      alignItems="center"
                      w="fit-content"
                    >
                      <SvgContainer
                        icon={getAppValue({
                          bibino: BibinoStore,
                          barkio: BarkioStore
                        })}
                      />
                      <Text ml="12px" fontWeight={600} fontSize="16px">
                        {t("appName")}
                      </Text>
                    </Flex>
                  )}
                </Flex>
              </Flex>
              <Flex columnGap="8px" mt="16px">
                <Number number={2} />
                <Subtitle textAlign="left" color="mediumEmphasis">
                  {t("howToInstall.step2")}
                </Subtitle>
              </Flex>
            </Flex>
          }
          bottom={
            <Flex flexDir="column" pb="32px" rowGap="16px">
              <Button
                py="14px"
                px="16px"
                onClick={() => navigate("/welcome")}
                minW="296px"
              >
                {t("buttons.done")}
              </Button>
              <Button
                py="14px"
                px="16px"
                minW="296px"
                variant="flatPrimary"
                onClick={() => openExternal({ env: "EMAIL" })}
              >
                {t("purchase.help.contactUs.heading")}
              </Button>
            </Flex>
          }
        ></SceneLayout>
      </FullScreen>
    </>
  );
}

export default DeviceInstall;
